import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
import MaterialCard from "@/components/material/Card.vue";
let ProfileView = class ProfileView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.dialog = false;
        this.formTitle = "Manual Entries";
        this.editedItem = {
            name: "",
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0
        };
        this.headers = [
            {
                text: "Customer",
                align: "left",
                sortable: true,
                value: "customer.fullName"
            },
            {
                text: "Transaction ID",
                sortable: true,
                value: "transactionId"
            },
            {
                text: "Description",
                sortable: false,
                value: "description"
            },
            {
                text: "Transaction Type",
                sortable: true,
                value: "transactionType"
            },
            {
                text: "Authorize.NET Reference ID",
                sortable: true,
                value: "paymentReferenceNumber"
            },
            {
                text: "Amount",
                sortable: false,
                value: "transactionAmount"
            }
        ];
        this.transactions = [
            {
                customer: {
                    fullName: "FirstName LastName",
                    organizationName: "Organization Name",
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    country: "",
                    phone: "",
                    fax: "",
                    email: "",
                    sourceReferenceId: "" /* Do not change this */
                },
                description: "TBD: Description",
                transactionType: "INV" /* Matt Do not Change This */,
                paymentReferenceNumber: "61899837846",
                transactionAmount: 100 /* Total order amount */,
                sourceSystem: "Configio",
                transactionDetails: [
                    {
                        longDescription: "" /* Put a long descirption here */,
                        amount: 100 /* Line item transaction amount */,
                        transactionDate: "",
                        quantity: 1 /* Always a quantity of 1 here */,
                        unitPrice: 100,
                        accountNumber: "",
                        subAccountNumber: "",
                        productAccountNumber: "",
                        serviceDate: "",
                        eventType: "" /* Goes into short description, can use any description */,
                        isRefund: false /* Do not change this */,
                        shortDescription: "",
                        purchaseOrderNumber: "" /* Can add purchase order number here */,
                        note: "Moving to the West ",
                        sourceReferenceId: "MANUAL" /* Do not change this */
                    }
                ],
                sourceReferenceId: "MANUAL" /* Do not change this */,
                transactionId: "1234"
            }
        ];
    }
    created() { }
    async mounted() {
        this.user = await this.authService.getUser();
    }
    close() {
        this.dialog = false;
    }
    save() {
        this.close();
    }
};
ProfileView = tslib_1.__decorate([
    Component({
        name: "ProfileComponent",
        components: {
            MaterialCard
        }
    })
], ProfileView);
export default ProfileView;
